import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { createConversation, getConversation, resetConversation, submitMessage } from 'actions/conversation';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import MessageForm from '../Form/MessageForm';
import ConversationHeader from './ConversationHeader';
import ConversationMessages from './ConversationMessages';
import { setPageTitle } from 'actions/header';
import { getConversationParticipants } from '../Helpers';

var ConversationPage = /*#__PURE__*/function (_Component) {
  _inherits(ConversationPage, _Component);

  var _super = _createSuper(ConversationPage);

  /* Class setup */
  function ConversationPage(props) {
    var _this;

    _classCallCheck(this, ConversationPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      var id = _this.props.match.params.id;

      if (id != 'new') {
        _this.props.getConversation(id).then(function () {
          _this.setTitle();

          _this.setState({
            loading: false
          });
        });
      } else {
        if (_this.props.staged == null) {
          _this.props.history.replace("/conversations/");
        }

        _this.setTitle();
      }

      window.addEventListener('resize', _this.onResize);
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var id = nextProps.match.params.id;

      if (id != _this.props.match.params.id && _this.state.loading == false) {
        _this.setState({
          loading: true
        });

        _this.props.getConversation(id).then(function () {
          _this.setTitle();

          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setTitle", function () {
      var user = _this.props.user;
      var id = _this.props.match.params.id;
      var members = null;

      if (id != 'new') {
        members = getConversationParticipants(_this.props.conversation, user);
      } else {
        members = getConversationParticipants(_this.props.staged, user);
      }

      if (members == null) {
        return null;
      }

      var title = '';
      members.forEach(function (member, index) {
        if (member != null) {
          if (index > 0) {
            title += ', ';
          }

          if (member.membershipType == 'SECTION_OWNERS') {
            title += member.title;
            return true;
          }

          if (member.membershipType == 'GUARDIAN') {
            member.lastName = (member.lastName != null ? member.lastName : '') + ' (' + _this.props.translate('Guardian') + ')';
          }

          title += member.firstName + ' ' + member.lastName;
        }
      });

      _this.props.setPageTitle(title);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.onResize);

      _this.props.resetConversation();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.onResize();
    });

    _defineProperty(_assertThisInitialized(_this), "submitMessage", function (values) {
      if (_this.props.conversation != null) {
        var lastMessage = _this.props.conversation.messages[_this.props.conversation.messages.length - 1];

        if (lastMessage == null) {
          values.parentId = null;
        } else {
          values.parentId = lastMessage.id;
        }
      } else {
        values.parentId = null;
      }

      return new Promise(function (resolve) {
        var conversation = _this.props.conversation;

        if (_this.props.match.params.id == 'new') {
          conversation = _this.props.staged;
        }

        var user = _this.props.user;
        values.creator = user.id;
        var owner_section = conversation.memberships.find(function (m) {
          return m.membershipType == 'SECTION_OWNERS';
        });

        if (owner_section != null) {
          values.senderId = owner_section.section.id;
          values.senderType = 'SECTION';
        } else {
          values.senderId = values.creator;
          values.senderType = 'USER';
        }

        if (_this.props.match.params.id == 'new') {
          // Send message with a conversation object
          var _conversation = _this.props.staged;
          _conversation.messages = [values];
          delete values.conversationID;

          _this.setState({
            loading: true
          });

          _this.props.createConversation(_conversation).then(function () {
            _this.props.history.replace("/conversations/".concat(_this.props["new"]));

            _this.props.getConversation(_this.props["new"]).then(function () {
              _this.setTitle();

              _this.setState({
                loading: false
              });

              resolve(1);
            });
          });
        } else {
          _this.props.submitMessage(values).then(function () {
            _this.setState({});

            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      var messages = document.querySelector('.conversation--wrapper');

      if (messages != null) {
        var height = 0;
        var body = document.querySelector('body');
        var footer = body.querySelector('.site-footer');
        var header = body.querySelector('.teams-header');
        var desktopHeader = body.querySelector('.desktop-header-spacing');
        var deviceMenu = body.querySelector('.footer-menu-bar-container');
        var deviceHeader = body.querySelector('.device-menu');
        height = window.innerHeight;

        if (footer != null) {
          height = height - footer.scrollHeight;
        }

        if (header != null) {
          height = height - header.scrollHeight;
        }

        if (desktopHeader != null) {
          height = height - desktopHeader.scrollHeight;
        }

        if (deviceMenu != null) {
          height = height - deviceMenu.scrollHeight - 15;
        }

        if (deviceHeader != null) {
          height = height - deviceHeader.scrollHeight;
        }

        messages.style.height = height - 25 + 'px';
      }
    });

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(ConversationPage, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
    /* Lifecycle methods */

  }, {
    key: "render",
    value:
    /* Render methods */
    function render() {
      var conversation = this.props.conversation;
      var disabled = false;

      if (this.props.match.params.id == 'new') {
        conversation = this.props.staged;
      }

      if (conversation != null && conversation.status == 'ARCHIVED') {
        disabled = true;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation--wrapper"
      }, /*#__PURE__*/React.createElement(ConversationHeader, {
        conversation: conversation
      }), /*#__PURE__*/React.createElement(ConversationMessages, {
        conversation: conversation
      }), /*#__PURE__*/React.createElement(MessageForm, {
        onSubmit: this.submitMessage,
        conversation: conversation,
        disabled: disabled
      })));
    }
  }]);

  return ConversationPage;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    conversation: state.Conversation.conversation,
    staged: state.Conversation.staged,
    "new": state.Conversation["new"]
  };
}

export default withRouter(connect(mapStateToProps, {
  getConversation: getConversation,
  submitMessage: submitMessage,
  createConversation: createConversation,
  resetConversation: resetConversation,
  setPageTitle: setPageTitle
})(ConversationPage));